import cx from 'classnames';
import {
    DELETED_ENTRY,
    EXPIRED_ENTRY,
    HIDDEN_ENTRY,
    INACTIVE_ENTRY,
} from 'mk/autogenerated/translations/ProductStateBadges.82c6a24f506d3d54fbb8f9aa244b11b0'
import { ProductEntity, ProductQuality } from 'mk2/apps/bazaar/schemas';
import { planChoosePlanUrl, planGetProUrl } from 'mk2/apps/plan/urls';
import { Link } from 'mk2/components/Link';
import { url } from 'mk2/helpers/urls';
import { Plan } from 'mk2/schemas';
import React from 'react';
import styles from './ProductStateBadges.mscss';

export type State = keyof ProductEntity['state'];

interface OwnProps {
    className?: string;
    product: ProductEntity;
    allowed?: State[];
}

const badges = {
    isInactive: { className: styles['ProductStateBadges__badge--inactive'], text: INACTIVE_ENTRY },
    isExpired: { className: styles['ProductStateBadges__badge--expired'], text: EXPIRED_ENTRY },
    isDeleted: { className: styles['ProductStateBadges__badge--deleted'], text: DELETED_ENTRY },
    isHidden: { className: styles['ProductStateBadges__badge--deleted'], text: HIDDEN_ENTRY },
};

const ProductStateBadges: React.FunctionComponent<OwnProps> = ({
    className,
    product,
    allowed = ['isInactive', 'isExpired', 'isDeleted'],
}) => {
    const user = product.seller.user;

    const badgesKeys: State[] =
        allowed.indexOf('isDeleted') !== -1 && product.state.isDeleted ? ['isDeleted'] : Object.keys(badges) as State[];

    const realBadges = badgesKeys.filter((key) => product.state[key] && allowed.indexOf(key) !== -1);

    if (!realBadges.length) {
        return null;
    }

    return (
        <div className={cx(styles.ProductStateBadges, className)}>
            {realBadges.map((key) => {
                const val = badges[key];
                const badge = (
                    <span key={key} className={cx(styles.ProductStateBadges__badge, val.className)}>
                        {val.text}
                    </span>
                );
                if (key === 'isHidden') {
                    let gotoUrl;
                    if (user.activePlan === Plan.PRO) {
                        gotoUrl = '';
                    } else if (user.activePlan === Plan.PLUS || product.quality === ProductQuality.NEW) {
                        gotoUrl = url(planGetProUrl, {}, { src: 'myBazaar' });
                    } else {
                        gotoUrl = url(planChoosePlanUrl, {}, { src: 'myBazaar' });
                    }
                    return (
                        <Link key={key} to={gotoUrl}>
                            {badge}
                        </Link>
                    );
                }
                return badge;
            })}
        </div>
    );
};

ProductStateBadges.displayName = 'ProductStateBadges';

export default ProductStateBadges;
